import React from 'react'
import classNames from 'classnames'
import { Profile } from '@/components/svg'

interface Props {
  avatarUrl?: string
  className?: string
  name: string
}

const UserAvatar: React.FC<Props> = ({ avatarUrl, className, name }) => {
  return (
    <span
      className={classNames(
        'flex h-8 w-8 items-center justify-center rounded-full bg-oxide-3 text-lg text-white',
        className
      )}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="avatar" className="w-2/3" />
      ) : name === 'Anonymous' || name === undefined ? (
        <Profile />
      ) : (
        name[0]
      )}
    </span>
  )
}

export default UserAvatar
